import React from 'react';
import { GetEventDetailsQuery } from 'types/generated/client';

type Sponsor = NonNullable<NonNullable<GetEventDetailsQuery['eventsByPk']>['sponsors']>[number];

interface Props {
  sponsors: Sponsor[];
}

export default function Sponsored({ sponsors }: Props) {
  if (!sponsors || sponsors.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-8">
      <h2 className="typography-product-heading-compact text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
        Sponsored by
      </h2>
      <div className="grid grid-cols-3 items-center gap-12 max-md:grid-cols-2 max-sm:grid-cols-1">
        {sponsors.map((sponsor) => (
          <img key={sponsor.id} src={sponsor.imageProviderUrl} alt={sponsor.name} />
        ))}
      </div>
    </div>
  );
}
